import { getLocaleLanguage } from "../Helper";

export const buildTranslationLoadPath = (
    languages: string[] = [],
    namespaces: string[] = []
) => {
    const language = getLocaleLanguage(languages[0] || 'en') || 'en';
    const namespace = namespaces[0] || 'translation';

    return `/translations/${language}/${namespace}.json`;
};
